// extracted by mini-css-extract-plugin
module.exports = {"year":"styles_year__33EvN","yearTitle":"styles_yearTitle__1Hd9w","yearIcon":"styles_yearIcon__25Uxj"};